/**
* カウントダウンのコンストラクタ
* @constructor
*/
module.exports = CountDown = function(){};

/**
* initialize
* @param {selector} el - jquery セレクタ
*/
CountDown.prototype.init = function(el){
  this.element = $(el);
  this.event();
}

/**
* event
*/
CountDown.prototype.event = function(){
  var self = this;

  var START_DATE = new Date(2017, 7, 26, 0, 0, 0);

  this.getServerDate().done(function(data, textStatus, xhr){
    var res = new Date(xhr.getResponseHeader('Date'));
    self.render(START_DATE, res);
  }).fail(function(){
    var res = new Date();
    self.render(START_DATE, res);
  });
}

CountDown.prototype.getServerDate = function(){
  return $.ajax({
    type : 'GET',
    url : window.location.href
  });
};

CountDown.prototype.render = function(start, today){
  var diff = start - today;
  var dayCount = this.getDiffTime(start - today);
  var date = (dayCount === undefined) ? '?' : dayCount[0]; 
  this.element.html(date);
};

CountDown.prototype.getDiffTime = function(x){
  var y = 24 * 60 * 60 * 1000;
  if(x >= 0){
    var day = Math.floor(x / y);
    var hour = Math.floor((x % y) / (60 * 60 * 1000));
    var minute = Math.floor((x % y) / (60 * 1000)) % 60;
    var second = Math.floor((x % y) / 1000) % 60 % 60;
    var msecond = Math.floor((x % y) / 10 ) % 100;
    var time = this.zeroPadding([day, hour, minute, second, msecond]);
    return time;
  }
};

CountDown.prototype.zeroPadding = function(array){
  var num = [];
  for(var i = 0; i < array.length; i++){
    num.push(('0' + array[i]).substr(-2));
  }
  return num;
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/countDown.js
// module id = 1
// module chunks = 0